import { pathInfo } from './const';
import {
  Home,
  Social,
  Campus,
  PositionList,
  Question,
  // CampusTV,
  PositionDetail,
  About,
  DeliverySuccess,
  Deliveryconfirm,
  Login,
  Beidou,
  QiHang,
  CampusSchedule,
  SharePosition,
  BeiDouProgram,
} from './list';

const config = [
  {
    component: Home,
    path: '/home',
    withHeaderAndFooter: true,
  },
  {
    component: Social,
    path: '/social',
    withHeaderAndFooter: true,
    isStickyHeader: true,
  },
  {
    component: Campus,
    path: '/campus',
    withHeaderAndFooter: true,
    isStickyHeader: true,
  },
  {
    component: PositionList,
    path: '/position',
    withHeaderAndFooter: true,
    isStickyHeader: true,
  },
  {
    component: PositionDetail,
    path: '/position/detail',
    withHeaderAndFooter: true,
    isStickyHeader: true,
  },
  {
    component: Question,
    path: '/question/:id',
    withHeaderAndFooter: true,
  },
  // {
  //   component: CampusTV,
  //   path: '/campus/tv',
  //   withHeaderAndFooter: true,
  // },
  {
    component: CampusSchedule,
    path: '/campus/schedule',
    withHeaderAndFooter: true,
    isStickyHeader: true,
  },
  {
    component: DeliverySuccess,
    path: '/delivery-success',
    withHeaderOnly: true,
    isStickyHeader: true,
  },
  {
    component: About,
    path: '/about/:id',
    withHeaderAndFooter: true,
  },
  // {
  //   component: AccountSetting,
  //   path: '/personalCenter/accountSetting',
  //   withHeaderOnly: true,
  //   isStickyHeader: true,
  //   // isAuth: true,
  // },
  {
    component: Deliveryconfirm,
    path: '/delivery-confirm',
    withHeaderOnly: true,
    isStickyHeader: true,
    isAuth: true,
  },
  // {
  //   component: DeliveryRecord,
  //   path: '/personalCenter/deliveryRecord',
  //   withHeaderOnly: true,
  //   isStickyHeader: true,
  //   // isAuth: true,
  // },
  {
    component: Login,
    path: '/login',
  },
  // {
  //   component: ResumeDetail,
  //   path: '/personalCenter/resumeDetail',
  //   withHeaderOnly: true,
  //   isStickyHeader: true,
  //   // isAuth: true,
  // },
  {
    component: Beidou,
    path: '/beidou',
    withHeaderAndFooter: true,
    isStickyHeader: true,
  },
  {
    component: BeiDouProgram,
    path: pathInfo.beidouprogram,
    withHeaderAndFooter: true,
  },
  {
    component: QiHang,
    path: '/qihang',
    withHeaderAndFooter: true,
    isStickyHeader: true,
  },
  // {
  //   component: PreViewResume,
  //   path: '/personalCenter/resumeDetail/preViewResume',
  //   withHeaderOnly: true,
  //   isStickyHeader: true,
  // },
  {
    component: SharePosition,
    path: '/share-position',
    withHeaderAndFooter: true,
    isStickyHeader: true,
  },
];

export default config;
